import { render } from "./Farms.vue?vue&type=template&id=22d68e13"
import script from "./Farms.vue?vue&type=script&lang=js"
export * from "./Farms.vue?vue&type=script&lang=js"

import exportComponent from "/home/forge/lf.m2geo.ie/releases/20261103161156/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Pages/Farmer/Partials/Farms.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "22d68e13"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('22d68e13', __exports__)) {
    console.log('reload')
    api.reload('22d68e13', __exports__)
  }
  
  module.hot.accept("./Farms.vue?vue&type=template&id=22d68e13", () => {
    console.log('re-render')
    api.rerender('22d68e13', render)
  })

}


export default __exports__